/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ChargeCalculation {
    REQUIRED = 'REQUIRED',
    OPTIONAL = 'OPTIONAL',
}
